import { AlertTriangle, Info } from "lucide-react";
import { cn } from "@/lib/utils";

export function Warnings({ items, testid = "contract-warnings" }) {
  if (!items?.length) return null;
  return (
    <div className="space-y-1.5" data-testid={testid}>
      {items.map((w, i) => (
        <div key={i} className={cn("flex items-start gap-2 rounded-md border px-3 py-2 text-sm",
          w.level === "danger" ? "border-rose-500/40 bg-rose-500/10 text-rose-800 dark:text-rose-300" : "border-amber-500/40 bg-amber-500/10 text-amber-800 dark:text-amber-300")}
          data-testid={`warning-${w.type}`}>
          {w.level === "danger" ? <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" /> : <Info className="w-4 h-4 mt-0.5 shrink-0" />}
          <span>{w.message}</span>
        </div>
      ))}
    </div>
  );
}
